export enum ChecklistReportPastChecklistChartSegmentIndex {
    Completed,
    InProgress,
    NotStarted,
}
